<template>
  <div class="bank-select">
    <div class="bank-title-head">แจ้งข้อมูลการชำระเงิน</div>
    <div class="icon-container">
      <label class="label">หลักฐานการโอน</label>
      <image-upload-and-resize
        v-bind="chooseIconDialog"
        @confirm="handleConfirmChooseIconDialog"
      ></image-upload-and-resize>
    </div>
    <div class="mb-3">
      <div class="label">ผู้จัดหาบริการ</div>
      <el-select
        :value="sellerTradeSelected"
        @change="handleChangeInput('sellerTradeSelect', $event)"
        clearable
        class="input-seller-trade"
      >
        <el-option
          v-for="t in sellerTradePartyOptions"
          :key="t.value"
          :label="t.label"
          :value="t.value"
        ></el-option>
      </el-select>
    </div>
    <div
      v-if="
        bankInformationBySellerTrade && bankInformationBySellerTrade.length > 0
      "
    >
      <div class="mb-3">
        <p>ธนาคารที่โอน</p>
        <div
          class="grid-bank"
          v-for="(bank) in bankInformationBySellerTrade"
          :key="bank.id"
        >
          <div>
            <input
              class="radio-option"
              type="radio"
              :value="true"
              name="bank"
              :checked="bank.isSelect"
              @change="handleChangeInput('bank', bank.id)"
            />
          </div>
          <img class="icon" :src="bank.iconUrl" v-if="bank.iconUrl" />
          <div>
            <div>{{ bank.label }}</div>
            <div>เลขที่บัญชี: {{ bank.value }}</div>
          </div>
        </div>
      </div>
      <div class="mb-3" v-if="channels && channels.length > 0">
        <p>วิธีการรับเงิน</p>
        <div
          class="grid-bank mb-2"
          v-for="(channel, channelIndex) in channels"
          :key="channelIndex"
        >
          <div>
            <input
              class="radio-option"
              type="radio"
              :value="true"
              name="channel"
              :checked="channel.isSelect"
              @change="handleChangeInput('channel', channel.id)"
            />
          </div>
          <img class="icon channel" :src="channel.icon" v-if="channel.icon" />
          <div>
            <div class="channel-detail">{{ channel.label }}</div>
            <div class="channel-detail bank-title">{{ channel.detail }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-3">
      <p>จำนวนเงินที่โอน</p>
      <el-input
        :value="value.slipAmount"
        @input="handleChangeInput('slipAmount', $event)"
      ></el-input>
    </div>
    <div class="mb-3">
      <p>ราคาสุทธิที่ได้</p>
      <el-input
        :value="netPrice"
        readonly
      ></el-input>
    </div>
    <div class="">
      <p>หมายเหตุ</p>
      <el-input
        type="textarea"
        rows="7"
        :value="value.bankNote"
        @input="handleChangeInput('bankNote', $event)"
      ></el-input>
    </div>
  </div>
</template>

<script>
import { Radio, Input, Option, Select } from "element-ui";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ScButton from "@/lib/components/ScButton";
import ImageUploadAndResize from "@/lib/components/ImageUploadAndResize";
import { baanRueJaiClient } from "@/dependencies";
import { toCamelCaseObject } from "@/lib/util";
import { formatDecimal } from "@/lib/formatter";

export default {
  components: {
    "el-input": Input,
    "el-radio": Radio,
    ImagePickerModal,
    ScButton,
    ImageUploadAndResize,
    "el-select": Select,
    "el-option": Option
  },
  props: ["value", "iconUrl", "totalPrice"],
  data() {
    return {
      isShowModal: false,
      sellerTradeParties: [],
      sellerTradeSelect: null,
      bankInformationBySellerTrade: [],
      channels: [],
      channelSelect: null,
      bankInformation: [],
      netPrice: null
    };
  },
  computed: {
    chooseIconDialog() {
      return {
        isShow: this.isShowModal,
        isPreviewImage: true
      };
    },
    sellerTradePartyOptions() {
      const sellerTradePartyOptions = this.sellerTradeParties.map((seller) => ({
        value: seller.id,
        label: seller.name
      }));

      return sellerTradePartyOptions;
    },
    sellerTradeSelected() {
      const sellerTradePartyIdByPackage = this.value.sellerTradePartyIdByPackage;

      this.bankInformationBySellerTrade = this.bankInformation.filter(
        (bankInfo) => bankInfo.sellerTradeId === sellerTradePartyIdByPackage
      ).map((bank) => {
        return {
          ...bank,
          isSelect: false
        }
      });

      return sellerTradePartyIdByPackage;
    }
  },
  created() {
    this.setupSellerTradeParties();
    this.setupBankInformation()
  },
  methods: {
    handleClickChooseIconButton() {
      this.showChooseIconDialog();
    },
    showChooseIconDialog() {
      this.isShowModal = true;
    },
    hideChooseIconDialog() {
      this.isShowModal = false;
    },
    handleCancelChooseIconDialog() {
      this.hideChooseIconDialog();
    },
    async handleConfirmChooseIconDialog(file) {
      this.$emit("input", { ...this.value, iconFile: file });
      this.hideChooseIconDialog();
    },
    async handleChangeInput(key, value) {
      if (key === "slipAmount") this.$emit("input", { ...this.value, slipAmount: value });
      if (key === "bankNote") this.$emit("input", { ...this.value, bankNote: value });

      if (key === "bank") {
        const bankSelected = this.bankInformation.find((bank) => bank.id === value);

        if (!bankSelected) {
          alert('เกิดข้อผิดพลาดในการเลือก ธนาคาร');
          return
        }

        this.channels = bankSelected.channels.map((channel) => {
          return {
            ...channel,
            isSelect: false
          }
        })

        this.$emit("input", {
          ...this.value,
          bankName: bankSelected.label,
          bankId: bankSelected.value,
        });

        return;
      }

      if (key === "sellerTradeSelect") {
        const banksBySellerTradePartyId = this.bankInformation.filter(
          (bankInfo) => bankInfo.sellerTradeId === value
        );

        this.channels = [];
        this.bankInformationBySellerTrade = banksBySellerTradePartyId.map((bank) => {
          return {
            ...bank,
            isSelect: false
          }
        });

          this.$emit("input", {
            ...this.value,
            sellerTradePartyIdByPackage: value,
          });

        return;
      }

      if (key === "channel") {
        this.channels = this.channels.map((chan) => {
          return {
            ...chan,
            isSelect: chan.id === value
          }
        })

        const channelSelects = this.channels.filter((chan) => chan.isSelect === true);

        if (channelSelects.length !== 1) {
          alert('เกิดข้อผิดพลาดในการเลือก วิธีการชำระเงิน');
          return
        }

        const channelSelect = channelSelects[0]

        if (channelSelect.feeType) {
          if (channelSelect.feeType === "BATH") {
            this.netPrice = formatDecimal(this.totalPrice - channelSelect.fee)
          } else if (channelSelect.feeType === "PERCENTAGE") {
            this.netPrice = formatDecimal(this.totalPrice * ((100 - channelSelect.fee) * 0.01))
          } else {
            this.netPrice = formatDecimal(this.totalPrice)
          }
        } else {
          this.netPrice = this.totalPrice
        }

        this.$emit("input", {
          ...this.value,
          channel: channelSelect.value,
          actualPrice: this.netPrice
        });

        return
      }
    },
    async setupSellerTradeParties() {
      try {
        this.sellerTradeParties = await this.fetchSellerTradeParties();
      } catch (err) {
        if (
          err.response
          && err.response.status
          && err.response.status === 400
        ) {
          alert(err.response.data.message);
          console.error(err);
        } else {
          alert(err.message);
          console.error(err);
        }
      }
    },
    async fetchSellerTradeParties() {
      const response = await baanRueJaiClient.admin.subscriptions.receipts.getSellerTradeParties();

      return response.data.result;
    },
    async setupBankInformation() {
      try {
        this.bankInformation = await this.fetchBankInformation()
      } catch (error) {
        console.error(error);

        alert("ไม่สามารถแสดงข้่อมูล บัญชีธนาคารได้");
        return
      }
    },
    async fetchBankInformation() {
      const response = await baanRueJaiClient.admin.subscriptions.subscribers.getBankInformationList()

      return toCamelCaseObject(response.data.result);
    }
  },
  watch: {
    totalPrice() {
      const chanelSelected = this.channels.find((channel) => channel.isSelect === true)
      
      if (chanelSelected) {
        this.handleChangeInput('channel', chanelSelected.id)
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
$logoSize: 64px;

.grid-bank {
  display: grid;
  height: 70px;
  grid-template-columns: 40px 80px 200px;
}

.bank-select {
  padding-top: 20px;
  border-top: $border-head;
}

.bank-title {
  font-size: 14px;
  font-weight: normal;
  color: $orange;

  &-head {
    font-size: 16px;
    font-weight: bold;

    padding-bottom: 20px;
  }
}

.icon-container {
  max-width: 180px;
}

.thumbnail {
  margin-bottom: 20px;

  border-radius: $border-radius;
  border: $border;
  width: 100%;
}

.thumbnail-button {
  display: block;
  width: 100%;
}

.radio-option {
  transform: scale(1.25);
  margin-right: 15px;
  margin-bottom: 10px;
  margin-top: 10px;
  margin-left: 10px;
}

.icon {
  display: block;
  margin-top: 0;

  border-radius: 8px;
  width: $logoSize;
  height: $logoSize;
  flex: 0 0 $logoSize;

  &.channel {
    border-top: 1px solid $orange;
    border-bottom: 1px solid $orange;
  }
}

.input-seller-trade {
  width: 400px;
}

.channel-detail {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/subscribers/components/BankSelect.vue